<template>
	<div id="qvo-app">
		<titlebar />
		<notificationCenter/>
		<navbar/>
		<main id="content" class="api">
			<h1>API</h1>
		</main>
		<footnote/>
	</div>
</template>

<script>
	//import { mapActions /*, mapState, mapGetters*/ } from 'vuex';

	export default {
		name: 'api',
	}
</script>

<!-- Page-Specific Style Import (don't edit here) -->
<style lang="scss">
</style>

